import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard"; //Material imports

import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import { withi18n } from "../../../../customer/components/hocs/i18n";

var HeaderIconButton = function HeaderIconButton(_ref) {
  var classes = _ref.classes,
      t = _ref.t,
      icon = _ref.icon,
      onButtonClick = _ref.onButtonClick,
      buttonId = _ref.buttonId,
      ariaLabel = _ref.ariaLabel,
      disabled = _ref.disabled,
      buttonClass = _ref.buttonClass,
      buttonStyle = _ref.buttonStyle,
      color = _ref.color,
      tooltip = _ref.tooltip,
      copyValue = _ref.copyValue,
      copyToClipboardFeature = _ref.copyToClipboardFeature;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1];

  var handleOnClick = function handleOnClick(event) {
    event.stopPropagation();
    handleTooltipClose();

    if (typeof onButtonClick === "function") {
      onButtonClick();
    }
  };

  var handleTooltipClose = function handleTooltipClose() {
    setOpen(false);
  };

  var handleTooltipOpen = function handleTooltipOpen() {
    setOpen(true);
  };

  var arrow = classes.arrow,
      primary = classes.primary,
      secondary = classes.secondary,
      primaryContrast = classes.primaryContrast,
      grey = classes.grey,
      otherClasses = _objectWithoutProperties(classes, ["arrow", "primary", "secondary", "primaryContrast", "grey"]);

  var colorClasses = {
    primary: primary,
    secondary: secondary,
    primaryContrast: primaryContrast,
    grey: grey
  };

  var renderIconButton = function renderIconButton() {
    return /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": ariaLabel ? ariaLabel : tooltip,
      id: buttonId,
      onClick: handleOnClick,
      disabled: disabled,
      style: buttonStyle,
      className: "".concat(colorClasses[color], " ").concat(buttonClass)
    }, icon);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tooltip, {
    open: open,
    onClose: handleTooltipClose,
    onOpen: handleTooltipOpen,
    disableFocusListener: true,
    title: /*#__PURE__*/React.createElement(React.Fragment, null, t(tooltip), /*#__PURE__*/React.createElement("span", {
      className: arrow,
      ref: setArrowRef
    })),
    classes: otherClasses,
    PopperProps: {
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      },
      anchorEl: document.getElementById(buttonId),
      placement: "bottom"
    }
  }, /*#__PURE__*/React.createElement("div", null, copyToClipboardFeature && /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: copyValue
  }, renderIconButton()), !copyToClipboardFeature && renderIconButton())));
};

var styles = function styles(theme) {
  return {
    tooltip: {
      position: "relative",
      fontWeight: 500
    },
    popper: {
      "&[x-placement*='bottom'] $arrow": {
        top: 0,
        left: 0,
        marginTop: "-0.95em",
        width: "2em",
        height: "1em",
        "&::before": {
          borderWidth: "0 1em 1em 1em",
          borderColor: "transparent transparent ".concat(theme.palette.grey[600], " transparent")
        }
      },
      "&[x-placement*='top'] $arrow": {
        bottom: 0,
        left: 0,
        marginBottom: "-0.95em",
        width: "2em",
        height: "1em",
        "&::before": {
          borderWidth: "1em 1em 0 1em",
          borderColor: "".concat(theme.palette.grey[600], " transparent transparent transparent")
        }
      },
      "&[x-placement*='right'] $arrow": {
        left: 0,
        marginLeft: "-0.95em",
        height: "2em",
        width: "1em",
        "&::before": {
          borderWidth: "1em 1em 1em 0",
          borderColor: "transparent ".concat(theme.palette.grey[600], " transparent transparent")
        }
      },
      "&[x-placement*='left'] $arrow": {
        right: 0,
        marginRight: "-0.95em",
        height: "2em",
        width: "1em",
        "&::before": {
          borderWidth: "1em 0 1em 1em",
          borderColor: "transparent transparent transparent ".concat(theme.palette.grey[600])
        }
      }
    },
    arrow: {
      position: "absolute",
      fontSize: 6,
      "&::before": {
        content: "''",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid"
      }
    },
    tooltipPlacementLeft: {
      margin: "0 8px"
    },
    tooltipPlacementRight: {
      margin: "0 8px"
    },
    tooltipPlacementTop: {
      margin: "8px 0"
    },
    tooltipPlacementBottom: {
      margin: "8px 0"
    },
    primary: {
      color: theme.palette.primary.main,
      "&:disabled": {
        color: theme.palette.contrast.text
      },
      "&:hover": {
        color: "rgba(0, 0, 0, 0.54)"
      }
    },
    secondary: {
      color: theme.palette.secondary.main
    },
    primaryContrast: {
      color: theme.palette.primary.contrastText,
      "&:disabled": {
        color: theme.palette.contrast.text
      }
    },
    grey: {
      "&:hover": {
        color: theme.palette.secondary.main
      }
    }
  };
};

export default withStyles(styles)(withi18n(HeaderIconButton));
HeaderIconButton.defaultProps = {
  disabled: false,
  buttonClass: "",
  buttonStyle: {},
  copyToClipboardFeature: false,
  copyValue: "",
  color: "grey"
};